import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useReactToPrint } from 'react-to-print';

//Servicios
import { DJCEService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJCE from './DJCE';
import { formatCoordinates } from '../../helpers';
import DJCEPrint from '../DJCEPrint/DJCEPrint';

//Estilos

function DJCPContainer() {
    const { user, token, masters, grapesVariety, formatNumber } =
        useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [WatchDJCELogs, setWatchDJCELogs] = useState(false);
    const [Coordinates, setCoordinates] = useState({});
    const [DJCEData, setDJCEData] = useState({});

    const Params = useParams();
    const PrintRef = useRef();

    //Formateador de coordenadas
    useEffect(() => {
        if (Object.keys(DJCEData).length > 0) {
            formatCoordinates(
                DJCEData.declaracion.ubicacion_X,
                DJCEData.declaracion.ubicacion_Y
            ).then((res) =>
                setCoordinates({
                    lat: res[0],
                    lon: res[1],
                })
            );
        }
    }, [DJCEData]);

    useEffect(() => {
        const getMyDJCE = async () => {
            try {
                setLoader(true);
                //Obtenemos la DJCE segun el id que esta en los params
                const MyDJCEs = await DJCEService.single({
                    token,
                    id: parseInt(Params.id),
                });
                //Si la respuesta es correcta seteamos el estado de myDJCP con los datos de la respuesta
                if (MyDJCEs) {
                    // const getNombreUsuario = await UserService.getNombreUsuario(
                    //     { token, usuarioId: MyDJCEs.data.usuario }
                    // );
                    // if (getNombreUsuario) {
                    setDJCEData({
                        ...MyDJCEs.data,
                        // ...getNombreUsuario.data,
                    });
                    // }
                }
                setLoader(false);
            } catch (err) {
                console.log(err);
                setLoader(false);
                return err;
            }
        };
        getMyDJCE();
    }, [Params.id]);

    //Funciones para imprimir la DJCE
    const handlePrint = useReactToPrint({
        content: () => PrintRef.current,
    });

    return loader ? (
        <Spinner />
    ) : (
        <>
            <DJCE
                functions={{
                    formatNumber,
                    handlePrint,
                    setWatchDJCELogs,
                }}
                states={{ user, WatchDJCELogs, DJCEData, masters, Coordinates }}
            />
            <DJCEPrint
                reference={PrintRef}
                functions={{
                    formatNumber,
                }}
                states={{
                    DJCEData,
                    masters,
                    grapesVariety,
                    Coordinates,
                }}
            />
        </>
    );
}

export default DJCPContainer;
